const ZOOM_RATIO = 2;
const OFFSET = 24;
let currentOverlay = null;

function createOverlay(image) {
  const overlay = document.createElement('div');
  overlay.className = 'image-magnify-full-size';
  overlay.ariaHidden = 'true';
  overlay.style.position = 'fixed';
  overlay.style.pointerEvents = 'none';
  const source = image.currentSrc || image.getAttribute('data-src') || image.src;
  overlay.style.backgroundImage = `url('${source}')`;
  overlay.style.backgroundColor = 'var(--gradient-background)';
  document.body.appendChild(overlay);
  return overlay;
}

function moveLens(image, overlay, event) {
  const ratio = image.height / image.width;
  const rect = image.getBoundingClientRect();
  const x = event.clientX - rect.left;
  const y = event.clientY - rect.top;
  overlay.style.backgroundPosition = `${x / (image.clientWidth / 100)}% ${y / ((image.clientWidth * ratio) / 100)}%`;
  overlay.style.backgroundSize = `${image.width * ZOOM_RATIO}px`;
  overlay.style.left = `${event.clientX + OFFSET}px`;
  overlay.style.top = `${event.clientY + OFFSET}px`;
}

function activateZoom(image, firstEvent) {
  if (!image.complete) {
    image.addEventListener('load', () => activateZoom(image, firstEvent), { once: true });
    return;
  }
  if (currentOverlay) currentOverlay.remove();
  const overlay = createOverlay(image);
  currentOverlay = overlay;
  moveLens(image, overlay, firstEvent);
  const follow = (e) => moveLens(image, overlay, e);
  image.addEventListener('mousemove', follow);
  image.addEventListener('mouseleave', () => {
    overlay.remove();
    currentOverlay = null;
    image.removeEventListener('mousemove', follow);
  }, { once: true });
}

document.querySelectorAll('.image-magnify-hover')
  .forEach(img => img.addEventListener('mouseenter', e => activateZoom(img, e)));
